module.exports = __webpack_public_path__ + "img/하이스피릿.eb02af7c.png";